export class SpellShardIconGenerator {
    constructor() {
        this.iconCache = new Map();
        this.tileSize = 100;
        this.svgNS = "http://www.w3.org/2000/svg";

        // Element lookup array matching your backend primitives order
        this.elementList = ["fire", "earth", "light", "wind", "cold", "water", "lightning", "dark"];

        this.spellColorRanges = {
            fire:       { h: [355, 10],  s: [70, 90],  l: [45, 55] },
            earth:      { h: [11, 40],   s: [80, 100], l: [25, 40] },
            light:      { h: [41, 60],   s: [80, 100], l: [50, 80] },
            wind:       { h: [80, 140],  s: [50, 80],  l: [40, 60] },
            cold:        { h: [170, 200], s: [60, 80],  l: [60, 75] },
            water:      { h: [210, 240], s: [70, 90],  l: [40, 55] },
            lightning:  { h: [260, 290], s: [50, 70],  l: [70, 80] },
            dark:       { h: [260, 290], s: [20, 40],  l: [10, 30] }
        };
    }   

    generateSpellColors(element) {
        const elementName = typeof element === 'number' ? this.elementList[element] : element.toLowerCase();
        const colorRange = this.spellColorRanges[elementName] || this.spellColorRanges.fire;
        
        const getMidpoint = (rangeArray) => Math.floor((rangeArray[0] + rangeArray[1]) / 2);

        // Fire unique fix: 5 is the mathematical midpoint between 355 and 10 on a 360-degree circle
        const h = elementName === "fire" ? 5 : getMidpoint(colorRange.h);
        const s = getMidpoint(colorRange.s);
        const l = getMidpoint(colorRange.l);

        const secondaryLightness = l > 50 ? l - 15 : l + 15;

        return [
            `hsl(${h}, ${s}%, ${l}%)`,                    
            `hsl(${h}, ${s}%, ${secondaryLightness}%)`     
        ];
    }

  
    generateIconColors(spellObj) {
        const element = spellObj.element ?? 0;
        return this.generateSpellColors(element);
    }

    generateIcon(spellObj) {
        const size = spellObj.tier || 1; 
        const [primaryColor, secondaryColor] = this.generateIconColors(spellObj);
        
        const boardPixelSize = size * this.tileSize;

        const svgElement = document.createElementNS(this.svgNS, "svg");
        svgElement.setAttribute("viewBox", `0 0 ${boardPixelSize} ${boardPixelSize}`);
        svgElement.classList.add("shard-icon");

        // Construct the physical grid nodes tree
        for (let row = 0; row < size; row++) {
            for (let col = 0; col < size; col++) {
                const useTag = document.createElementNS(this.svgNS, "use");
                // Aligned to point exactly to your template template ID
                useTag.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#icon-square");

                const xPos = col * this.tileSize;
                const yPos = row * this.tileSize;
                useTag.setAttribute("x", xPos.toString());
                useTag.setAttribute("y", yPos.toString());

                // Assign structure formatting layout
                const isEven = (row + col) % 2 === 0;
                useTag.classList.add(isEven ? "tile-even" : "tile-odd");

                svgElement.appendChild(useTag);
            }
        }

        // CRITICAL FIX: Put colors directly onto the generated SVG element wrapper.
        // This ensures every icon handles its own color parameters context independently!
        svgElement.style.setProperty("--color-primary", primaryColor);
        svgElement.style.setProperty("--color-secondary", secondaryColor);

        return svgElement;
    }

    /**
     * Public entry interface using cached allocations to save system processing loops
     */
    getIcon(uuid, spellObj) {
        if (this.iconCache.has(uuid)) {
            return this.iconCache.get(uuid).cloneNode(true); // Clone prevents DOM displacement bugs
        }

        const newSvgElement = this.generateIcon(spellObj);
        this.iconCache.set(uuid, newSvgElement);
        
        return newSvgElement;
    }


}